import * as React from "react";

export enum TYPE {
    NONE = "NONE",
    MESSAGE = "MESSAGE",
    PROGRESS = "PROGRESS",
    INFINITE_LOADING = "INFINITE_LOADING"
}

export enum STATUS {
    NONE = "NONE",
    ERROR = "ERROR",
    WARNING = "WARNING",
    SUCCESS = "SUCCESS"
}

export const actions = {
    SET_ACTION_SPINNER: "SET_ACTION_SPINNER",
    UPDATE_ACTION_SPINNER: "UPDATE_ACTION_SPINNER",
    DELETE_ACTION_SPINNER: "DELETE_ACTION_SPINNER",
    RESET_ACTION_SPINNER_STATE: "RESET_ACTION_SPINNER_STATE",

    SET_ACTION_SPINNER_NOTIFICATION_PAYLOAD: "SET_ACTION_SPINNER_NOTIFICATION_PAYLOAD"
};

export interface ISpinner {
    key: string;
    type: TYPE,
    status: STATUS,
    message: string | React.ReactNode,
    notification: any
}

export interface IActionSpinner {
    isOpen: boolean;
    loadingMap: Map<string, ISpinner>;
}

const stateObj: IActionSpinner = {
    isOpen: false,
    loadingMap: new Map()
};

export default (state = stateObj, action: { type: string, payload: any }) => {

    state = {...state};

    switch (action.type) {
        case actions.RESET_ACTION_SPINNER_STATE:
            state.isOpen = false;
            state.loadingMap = new Map();
            return state;
        case actions.SET_ACTION_SPINNER:
            state.isOpen = true;
            state.loadingMap.set(action.payload, {
                key: action.payload,
                status: STATUS.NONE,
                type: TYPE.INFINITE_LOADING,
                message: "",
                notification: {message: "", done: 0, complete: 0, failed: 0, total: 0}
            });
            return state;
        case actions.UPDATE_ACTION_SPINNER:
            state.loadingMap.set(action.payload.key, action.payload.spinner);
            return state;
        case actions.DELETE_ACTION_SPINNER:
            state.loadingMap.delete(action.payload);
            if (state.loadingMap.size === 0) {
                state.isOpen = false;
            }
            return state;
        case actions.SET_ACTION_SPINNER_NOTIFICATION_PAYLOAD: {
            const spinner = state.loadingMap.values().next().value as ISpinner;
            if (spinner) {
                if (spinner.type === TYPE.INFINITE_LOADING) {
                    spinner.type = TYPE.PROGRESS;
                }
                spinner.notification = action.payload;
            }
        }
            return state;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./app/reducers/actionSpinner.ts